// extracted by mini-css-extract-plugin
export default {"emailAlert":"BEmailSendingConfigForm-module_emailAlert_d44b5f0b"};